<template>
  <div class="hello">
    <div class="subTitle">百色天立小初</div>
    <div class="payButton">
      <van-button
          v-for="item in payButtons"
          :key="item.label"
          round
          block
          size="large"
          icon="bill-o"
          :color="buttonGradient"
          class="pay-btn"
          @click="goTo(item.url)"
      >
        {{ item.label }}
      </van-button>
    </div>
  </div>
</template>


<script>
export default {
  name: 'bstlxc',
  data() {
    return {
      // 按钮配置数组（可维护性强）
      payButtons: [
        {
          label: '学费',
          url: 'https://common-cspay.cibfintech.com/?data=xNfAx9eiKGd8f37edaf21f4373DFDz2lVKJtBQKy9Wx2+Qc1jC5nzmHEoR75on6fa+/uCauuoytRIgfSamzZGm60vC2HuPxyM7wXNDjISmUJg4FdRxTedq5BNb5OQf+glR9Vbb+nE3pJcwWwDbxSt97q/eOEql0uKW92xCvPn5cQKPH4L66LQVDN8oI='
        },
        {
          label: '餐费',
          url: 'https://common-cspay.cibfintech.com/?data=xNfAx9eiKGd8f37edaf21f4373DFDz2lVKJtBW6P1DihOuJZX2mi7m4raw9XkMuWCbuSxub8xMoQ4mtclArWLyqUwi5RRQkhkXUf+r0NuNxxTK8Betv568gItXEqMP/eot7SUVa4rSDAQEaHzMGP7T7gaySIVXnHCwB3+xOuSjfS3ILNpiuOLT8Fhx8='
        },
        {
          label: '素养服务',
          url: 'https://common-cspay.cibfintech.com/?data=xNfAx9eiKGd8f37edaf21f4373DFDz2lVKJtBaLNAtgbQwyUcsacXsIMr/lXkMuWCbuSxub8xMoQ4mtc9QR8qca37XRkILA0KikNz5VMhmkJxAWGNoemo1GHm0JsNJvbDnNy3b8UcTOA434p+gfxUh4N9/1zVxwKIyR8hc0xgGFaGUW35s6+pdxgoKI='
        },
        {
          label: '综合服务',
          url: 'https://common-cspay.cibfintech.com/?data=KoJTj55Y6Vd8f37edaf21f4373Vg5oDmh4XmMyXKGs+Rf6owGTgMt6arQNCfyGfO1PplN6gkIH5lgsNUzfMCvklU31Yys3iiweGMk0bAyd69+E9jGlA8CHSw8dBUNfFl0B1PY/trCDDzHcpXdvC13nj96792ehM5Mbc9rrs1g+d+s94U6w7xajwXp2E='
        }
      ],
      buttonGradient: 'linear-gradient(to right, #0055ff, #00aaff)',
    };
  },
  created() {
    document.title = '百色天立小初';
  },
  methods: {
    goTo(url) {
      window.location.href = url;
    }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.subTitle {
  margin-top: 10px;
  font-size: 28px;
  padding-bottom: 16px;
  text-align: center;
}

.payButton {
  margin: 20px auto;
  width: 75vw;
}

.pay-btn {
  margin-bottom: 16px; /* 替代 br 和 div 高度 */
}
</style>

